// helper method for making sure the rendering is drawn before calling our custom CSS styling afterwards
// https://stackoverflow.com/a/34999925/23716571
export const onNextFrame = (callback: () => void) => {
    setTimeout(() => {
        window.requestAnimationFrame(callback);
    });
}